import React, {useContext, useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { FirebaseContext } from '../../Services/firebase'

export default function UpdateDay(props) {
    const firebase = useContext(FirebaseContext)

    const [Day, setDay] = useState([]);
    const [SaveDate, setSaveDate] = useState('');

    useEffect(() => {
        const getContent = () => {
            firebase.getMenusDate(props.uid, props.week, props.day).get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    firebase.getMenusContent(props.uid, props.week, props.day, doc.id).get()
                    .then( doc => {
                        const mydata = doc.data()
                        console.log(mydata)
                        setDay(mydata)
                        setSaveDate(mydata.date)
                    })
                })
            })
        }
        getContent()
    }, [firebase, props.day, props.uid, props.week]);

    const handleChange = e => {
        setDay({...Day, [e.target.id]: e.target.value})
    }

    return (
        <div style={{display: "flex", flexDirection: "column", width: "70vw"}}>
            <TextField id="date" label="date" type="date" value={Day.date} sx={{ width: 220 }} InputLabelProps={{shrink: true,}} onChange={handleChange} size="small"/>
            <h4>Menu A</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeA" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platA" label="Plat" sx={{ width: 300}} size="small" value={Day.platA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageA" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageA} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertA" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertA} onChange={handleChange}/>
            </div>
            <h4>Menu B</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeB" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platB" label="Plat" sx={{ width: 300}} size="small" value={Day.platB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageB" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageB} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertB" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertB} onChange={handleChange}/>
            </div>
            <h4>Menu diabétique</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeD" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platD" label="Plat" sx={{ width: 300}} size="small" value={Day.platD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageD" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageD} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertD" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertD} onChange={handleChange}/>
            </div>
            <h4>Menu haché</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeH" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platH" label="Plat" sx={{ width: 300}} size="small" value={Day.platH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageH" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageH} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertH" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertH} onChange={handleChange}/>
            </div>
            <h4>Menu sans sel</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSS" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSS" label="Plat" sx={{ width: 300}} size="small" value={Day.platSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSS" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageSS} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSS" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertSS} onChange={handleChange}/>
            </div>
            <h4>Menu sans viande</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSV" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSV" label="Plat" sx={{ width: 300}} size="small" value={Day.platSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSV" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageSV} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSV" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertSV} onChange={handleChange}/>
            </div>
            <h4>Menu sans poisson</h4>
            <div style={{display: "flex"}}>
                <TextField id="entreeSP" label="Entrée" sx={{ width: 300}} size="small" value={Day.entreeSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="platSP" label="Plat" sx={{ width: 300}} size="small" value={Day.platSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="laitageSP" label="Laitage" sx={{ width: 300}} size="small" value={Day.laitageSP} onChange={handleChange}/>
            </div>
            <div style={{display: "flex", marginTop: "1vh"}}>
                <TextField id="dessertSP" label="Dessert" sx={{ width: 300}} size="small" value={Day.dessertSP} onChange={handleChange}/>
            </div>
            <h4>Potage</h4>
            <div style={{display: "flex"}}>
                <TextField id="potage" label="Potage" sx={{ width: 300}} size="small" value={Day.potage} onChange={handleChange}/>
            </div>
            <h4>Diner Léger</h4>
            <div style={{display: "flex"}}>
                <TextField id="diner" label="Diner léger" sx={{ width: 300}} size="small" value={Day.diner} onChange={handleChange}/>
            </div>
            <Button variant="contained" endIcon={<SaveAltIcon />} style={{marginTop: "1vh", width: "10vw"}} onClick={saveDay}>Sauvegarder</Button>
        </div>
    )
    function saveDay() {
        try {
            if (SaveDate !== "") {
                firebase.deleteDay(props.uid, props.week, props.day, SaveDate)
                firebase.newDay(props.uid, props.week, props.day, Day)
                .then(
                    alert('Le menu de ce jour a bien été modifié')
                )
                .catch(error => {
                    alert(error.message)
                })
            } else {
                firebase.newDay(props.uid, props.week, props.day, Day)
                .then(
                    alert('Le menu de ce jour a bien été modifié')
                )
                .catch(error => {
                    alert(error.message)
                })
            }
        }catch(err) {
            alert(err)
        }
    }
}